import type { ReactNode } from "react";

interface PanelProps {
  title?: string;
  description?: string;
  children: ReactNode;
  className?: string;
  action?: ReactNode;
}

export function Panel({ title, description, children, className = "", action }: PanelProps) {
  return (
    <section
      className={className}
      style={{
        background: "var(--color-bg-panel)",
        border: "1px solid var(--color-border)",
        borderRadius: "var(--radius-panel)",
        overflow: "hidden",
      }}
    >
      {title && (
        <div
          style={{
            padding: "10px var(--spacing-panel)",
            borderBottom: "1px solid var(--color-border)",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <span className="label" style={{ fontSize: 11 }}>
              {title}
            </span>
            {action && <div>{action}</div>}
          </div>
          {description && (
            <p
              style={{
                margin: "4px 0 0",
                fontSize: 11,
                color: "var(--color-text-muted)",
                lineHeight: 1.5,
              }}
            >
              {description}
            </p>
          )}
        </div>
      )}
      <div style={{ padding: "var(--spacing-panel)" }}>{children}</div>
    </section>
  );
}
